import { Tag } from "antd"
import type React from "react"
import { useTranslation } from "react-i18next"

import { ActionTooltip } from "../../../../components/ActionTooltip.tsx"

export function StatusTag({
  style,
  tooltipKey,
  label,
  className
}: {
  style?: React.CSSProperties
  tooltipKey?: string
  label?: React.ReactNode
  className?: string
}) {
  const { t } = useTranslation()

  if (!tooltipKey) {
    return (
      <Tag style={style} className={className}>
        {label}
      </Tag>
    )
  }

  return (
    <ActionTooltip title={t(tooltipKey)}>
      <Tag style={style} className={className} tabIndex={0}>
        {label}
      </Tag>
    </ActionTooltip>
  )
}
